<template>
    <div v-loading="loading">
        <zm-form label-position="left" class="demo-table-expand" label-width="110px">
            <zm-form-item label="channelId">
                {{ channelId }}
            </zm-form-item>
            <zm-form-item label="channelName">{{ channelName }}</zm-form-item>
            <zm-form-item label="clusterType">{{ clusterType }}</zm-form-item>
            <zm-form-item label="status">
                <img class="point" v-if="clusterStatus === 'RED'" src="../../assets/red-point.png">
                <img class="point" v-if="clusterStatus === 'GREEN'" src="../../assets/green-point.png">
                <img class="point" v-if="clusterStatus === 'YELLOW'" src="../../assets/yellow-point.png">
            </zm-form-item>
            <zm-form-item label="currentLoad">
                {{ currentLoad }}
            </zm-form-item>
            <zm-form-item label="sslActive">
                <img class="point" v-if="sslActive === false" src="../../assets/red-point.png">
                <img class="point" v-if="sslActive" src="../../assets/green-point.png">
            </zm-form-item>
            <zm-form-item label="sslEndPoint">
                {{ sslEndPoint }}
            </zm-form-item>
            <zm-form-item label="enableAlert">
                {{ enableAlert }}
            </zm-form-item>
            <zm-form-item label="enableJMX">
                {{ enableJMX }}
            </zm-form-item>
            <zm-form-item label="kafkaVersion">
                {{ kafkaVersion }}
            </zm-form-item>
            <zm-form-item label="tags" v-if="tags">
                <zm-tag type="" size="mini" v-for="item in Object.keys(tags)" :key="item">{{ item }}: {{ tags[item] }}</zm-tag>
            </zm-form-item>
            <zm-form-item label="createdTime">
                {{ setTime(createdTime) }}
            </zm-form-item>
            <zm-form-item label="modifiedTime">
                {{ setTime(modifiedTime) }}
            </zm-form-item>
        </zm-form>
        <zm-table :data="nodeInfos" border>
            <zm-table-column prop="id" label="id" align="center" width="80px"></zm-table-column>
            <zm-table-column prop="host" label="host" align="center"></zm-table-column>
            <zm-table-column prop="nodeRole" label="nodeRole" align="center"></zm-table-column>
            <zm-table-column prop="nodeStatus" label="nodeStatus" align="center"></zm-table-column>
            <zm-table-column prop="config" label="config" align="center" width="90px">
                <template slot-scope="scope">
                    <zm-popover width="600"
                        @show="getBrokerConfig(scope.row)"
                        placement="left-start" style="margin-right: 2px;"
                        trigger="click">
                        <div>
                            <zm-tabs v-model="activeTab">
                                <zm-tab-pane v-for="item in Object.keys(scope.row.configs)" :key="item" :name="item" :label="item">
                                    <div style="max-height: 400px;overflow:scroll">
                                        <p v-for="config in scope.row.configs[item]" :key="config.key">
                                        {{ config.key }}: {{ config.value }}</p>
                                    </div>
                                </zm-tab-pane>
                            </zm-tabs>
                        </div>
                        <zm-button slot="reference" type="icon" icon="zm-icon-eyes" :loading="scope.row.configLoading"></zm-button>
                    </zm-popover>
                </template>
            </zm-table-column>
            <zm-table-column prop="logDir" label="logDir" align="center" width="110px">
                <template slot-scope="scope">
                    <!-- <zm-popover
                        @show=""
                        placement="left-start" style="margin-right: 2px;"
                        trigger="click">
                        <div>
                            <p v-for="item in scope.row.configs" :key="item.key">
                                {{ item.key }}: {{ item.value }}</p>
                        </div> -->
                    <!-- <div v-if="scope.row.logDir.length" style="display: inline;">
                        <zm-button v-for="item in scope.row.logDir" :key="item.logDir"
                        @click="showLogDir(item)" type="link">{{ item.logDir }}</zm-button>
                    </div> -->
                    <zm-button type="icon" icon="zm-icon-eyes"
                    @click="getBrokerLogDir(scope.row)" :loading="scope.row.logDirLoading"></zm-button>
                    <!-- </zm-popover> -->
                </template>
            </zm-table-column>
        </zm-table>
        <zm-dialog :title="'Broker-' + logDirTitleBrokerId + ' Log Dir'" :visible.sync="visible" show-close append-to-body width="80%">
            <zm-tabs v-model="activeLogDir" type="card" @tab-click="handleClick">
                <zm-tab-pane v-for="item in logDirs" :key="item.logDir" :label="item.logDir" :name="item.logDir">
            <p>error: {{ item.error }}</p>
            <zm-table :data="item.kafkaReplicaInfos.slice((pageable.pageNumber - 1) * pageable.pageSize, pageable.pageNumber * pageable.pageSize)">
                <zm-table-column label="topicPartition" prop="topicPartition" show-overflow-tooltip></zm-table-column>
                <zm-table-column label="offsetLag" prop="offsetLag" width="120px"></zm-table-column>
                <zm-table-column label="size" prop="size" width="150px"></zm-table-column>
                <zm-table-column label="isFuture" prop="isFuture" width="120px">
                    <template slot-scope="scope">
                        <i :class="scope.row.isFuture ? 'zm-icon-ok' : 'zm-icon-close'"></i>
                    </template>
                </zm-table-column>
            </zm-table>
            <div style="text-align: center" class="pagination-wrap">
                <zm-pagination @size-change="handleSizeChange"
                    :current-page.sync="pageable.pageNumber"
                    :page-size="pageable.pageSize"
                    :page-sizes="[10, 20, 50, 100, 500, 1000]"
                    layout="sizes, total, prev, pager, next, jumper"
                    :total="item.kafkaReplicaInfos.length">
                </zm-pagination>
            </div>
                </zm-tab-pane>
            </zm-tabs>
        </zm-dialog>
        </div>
</template>
<script>
import {
    getClusterById, describeBrokerAllConfig, getBrokerLogDir
} from '@/api/kafkaManage'
export default {
    name: 'kafkaDetail',
    props: ['id'],
    data () {
        return {
            hasPermission: localStorage.role === 'SUPER_ADMIN' || localStorage.role === 'ADMIN',
            loading: true,
            channelName: '',
            clusterType: '',
            nodeInfos: [],
            clusterStatus: '',
            channelId: '',
            currentLoad: '',
            sslActive: '',
            sslEndPoint: '',
            visible: false,
            logDirTitleBrokerId: '',
            activeLogDir: '',
            logDirs: [],
            createdTime: '',
            modifiedTime: '',
            kafkaVersion: '',
            tags: null,
            enableJMX: '',
            enableAlert: '',
            activeTab: '',
            pageable: {
                pageNumber: 1,
                pageSize: 10,
                total: 0
            }
        }
    },
    created () {
       this.fetchData()
    },
    methods: {
        setTime (cellValue) {
            return new Date(parseInt(cellValue)).toLocaleString()
        },
        handleSizeChange (val) {
            this.pageable.pageSize = val
        },
        getBrokerConfig (row) {
            if (!Object.keys(row.configs).length) {
                row.configLoading = true
                describeBrokerAllConfig(this.channelId, row.id).then(response => {
                    row.configLoading = false
                    Object.keys(response).map(item => {
                        row.configs[item] = Object.keys(response[item]).map(config => {
                            return {
                                key: config,
                                value: response[item][config]
                            }
                        })
                    })
                }).catch(() => {
                    row.configLoading = false
                })
            }
        },
        getBrokerLogDir (row) {
            // if (!row.logDir.length) {
                row.logDirLoading = true
                getBrokerLogDir(this.channelId, row.id).then(response => {
                    row.logDir = response.listBrokerLogDirResult.logDirs.map(item => {
                        const data = response.listBrokerLogDirResult.kafkaLogDirInfoMap[item]
                        data.logDir = item
                        return data
                    })
                    row.logDirLoading = false
                    this.showLogDir(row)
                }).catch(() => {
                    row.logDirLoading = false
                })
            // }
        },
        showLogDir (row) {
            this.logDirTitleBrokerId = row.id
            this.logDirs = row.logDir
            this.activeLogDir = this.logDirs[0].logDir || ''
            this.visible = true
        },
        handleClick () {
            this.pageable.pageNumber = 1
        },
        fetchData () {
            this.loading = true
            getClusterById(this.id).then(response => {
                this.channelId = response.channelId
                this.channelName = response.channelName
                this.clusterType = response.clusterType
                this.nodeInfos = response.nodeInfos.map(item => {
                    const data = item
                    data.configLoading = false
                    data.configs = {}
                    data.logDirLoading = false
                    data.logDir = []
                    return data
                })
                this.clusterStatus = response.clusterStatus
                this.sslEndPoint = response.sslEndPoint
                this.sslActive = response.sslActive
                this.currentLoad = response.currentLoad
                this.createdTime = response.createdTime
                this.modifiedTime = response.modifiedTime
                this.kafkaVersion = response.kafkaVersion
                this.tags = response.tags
                this.enableJMX = response.enableJMX
                this.enableAlert = response.enableAlert
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        }
    }
}
</script>
